export const SET_USERS = "SET_USERS";
export const SET_USER_MAILBOX = "SET_USER_MAILBOX";
export const SET_USER_SERVER = "SET_USER_SERVER";

export const USER_VISIBLE_STATUSES = ["active", "trialing", "past_due"];
